// Shown wherever a user flagged for non-attendance is stopped from entering ballots or buying papering tickets
export const nonAttendanceMessage =
	"Your account has been flagged because you have previously won tickets to an event that you did not attend. If you would like to appeal this, please contact office@concertsforcarers.org.uk"

// Shown in place of the registration forms while the API has these registrations paused
export const nonNhsRegistrationPausedMessage =
	"New registrations for other organisations are temporarily paused. If you work for the NHS, you can still register with your NHS email address. Please check back soon."
export const organisationRegistrationPausedMessage =
	"New organisation registrations are temporarily paused. Please check back soon."

// The API's message codes for a paused registration
export const registrationPausedCodes = ["NonNhsRegistrationDisabled", "OrganisationRegistrationDisabled"]
